<script>
  import options from './FrivilligeCheckoutStepTwo.options'
  export default options
</script>

<template>
  <article class="kb-forms kb-frivillige-checkout-step-two">

    <template v-if="containsUdlaansvare">
      <div v-if="getLabel('udlaanText')" class="kb-frivillige-checkout-content__message">
        <p>{{ getLabel('udlaanText') }}</p>
      </div>

      <div class="kb-checkout-step-one__form-wrapper">  
        <FormInputDateField
            isRequired
            v-model="udlaanStartDate"
            fieldName="udlaanStartDate"
            :modelValue="udlaanStartDate"
            :minDate="udlaanMinStartDate"
            type="date"
            :label="getLabel('udlaanStartDateLabel')"
            :isValidationError="isUdlaanStartDateValid"
            :placeholder="getLabel('udlaanStartDatePlaceholder')"
            :errorMessageLabel="getLabel('udlaanStartDateError')"
            />
        <FormInputDateField
            isRequired
            v-model="udlaanEndDate"
            fieldName="udlaanEndDate"
            :modelValue="udlaanEndDate"
            :minDate="udlaanMinEndDate"
            type="date"
            :label="getLabel('udlaanEndDateLabel')"
            :isValidationError="isUdlaanEndDateValid"
            :placeholder="getLabel('udlaanEndDatePlaceholder')"
            :errorMessageLabel="getLabel('udlaanEndDateError')"
            />
            
          </div>

      <FormInputTextarea 
        v-model="udlaanComment"
        fieldName="udlaanComment"
        :modelValue="udlaanComment"
        :label="getLabel('udlaanCommentLabel')"
        />
        
        <hr />
        <h2 class="kb-checkout-content__title" aria-live="polite">Levering</h2>
    </template>

    <CheckoutStepTwo :hideCompany="true" :hideDepartment="true" :onSubmitCallback="onSubmit">
      <template v-slot:pickupAddressMessage v-if="containsUdlaansvare && getLabel('udlaanDeliveryText')">
        <div class="kb-frivillige-checkout-content__message">
          <p>{{ getLabel('udlaanDeliveryText') }}</p>
        </div>    
      </template>
    </CheckoutStepTwo> 
  </article>
</template>
